import React from 'react';
import { FieldChangeGrid } from '@pages/admin/audit-log/change-grid';
import {
    getFieldChangeItems,
    getProcessedFieldChangeItems,
    removePropertiesFromObject,
} from '@pages/admin/audit-log/service';

type RecordProps = {
    id?: number;
    description: string;
    OwnerName?: string;
    CompletedDate?: string;
    Status?: string;
    RequestedDate?: string;
    Description?: string;
    DueDate?: string;
    Resolution?: string;
    Comments?: string;
    SiteName?: string;
};

type ObservationChangeGridProps = {
    oldRecord: Partial<RecordProps>;
    newRecord: Partial<RecordProps>;
    oldItem?: Record<string, unknown>;
    newItem?: Record<string, unknown>;
};

const SMReviewType = ({ oldRecord, newRecord, oldItem, newItem }: ObservationChangeGridProps) => {
    const propArray = ['IsDeleted'];

    const refactoredOldRecord = {
        ...oldRecord,
        ...removePropertiesFromObject(oldRecord, propArray),
    } as Record<string, unknown>;

    const refactoredNewRecord = {
        ...newRecord,
        ...removePropertiesFromObject(newRecord, propArray),
    } as Record<string, unknown>;

    const items = getFieldChangeItems(refactoredOldRecord, refactoredNewRecord, null, (field: string) =>
        getProcessedFieldChangeItems({
            oldRecord: refactoredOldRecord,
            newRecord: refactoredNewRecord,
            oldItem,
            newItem,
            field,
        }),
    );

    return <FieldChangeGrid items={items} />;
};

export { SMReviewType };
